export const DEFAULT_PRESET_GROUP = "general";
export const CUSTOMER_PRESET_GROUP = "customer";

export const COLOR_PROPS = {
  LOW: "low_color",
  MEDIUM: "medium_color",
  HIGH: "high_color"
} as const;

export const PRESET_GROUPS = [
  "general",
  "bone",
  "cloth",
  "hair",
  "metal",
  "leather",
  "magic",
  "plastic",
  "skin",
  "stone",
  "wood"
];

export const PRESET_GROUP_FDM_EXCEPTION = ["metal", "magic", "hair", "custom"];
export const PresetIcons = {
  // bone: require("~app/assets/paint/bone.zip"),
  // cloth: require("~app/assets/paint/cloth.zip"),
  // hair: require("~app/assets/paint/hair.zip"),
  // metal: require("~app/assets/paint/metal.zip"),
  // leather: require("~app/assets/paint/leather.zip"),
  // magic: require("~app/assets/paint/magic.zip"),
  // plastic: require("~app/assets/paint/plastic.zip"),
  // skin: require("~app/assets/paint/skin.zip"),
  // stone: require("~app/assets/paint/stone.zip"),
  // wood: require("~app/assets/paint/wood.zip"),
  general: "resources/paint/general.zip"
};

export const PaintIcons = {
  HOVER: "/resources/icons/fill_hover.svg",
  FILL: "/resources/icons/fill_c.svg",
  PICK: "/resources/icons/pick.svg",
  ERASER: "/resources/icons/eraser.svg"
};
